<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-users-cog icon"></i>
        Usuarios
      </div>

      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{ name: 'administrativeHome' }">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{ name: 'users' }">
                <span>
                  <i class="fas fa-user-cog icon"></i>
                  Usuarios
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <createUser
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :closeBasic="closeBasic"
          :chargeListUser="chargeListUser"
          :user_id="user_id"
        ></createUser>
        <div class="box">
          <b-button type="is-primary is-small" @click="openBasic()"
            >Crear Usuario</b-button
          >
          <b-table
            type="is-primary"
            :data.sync="listUsers"
            :loading="loading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="id" label="ID" width="40" numeric>{{
                props.row.id
              }}</b-table-column>

              <b-table-column field="name" label="Nombre">{{
                props.row.name
              }}</b-table-column>

              <b-table-column field="apepat" label="Apellido Paterno">{{
                props.row.pather_lastname
              }}</b-table-column>

              <b-table-column field="apemat" label="Apellido Materno">{{
                props.row.mother_lastname
              }}</b-table-column>
              <b-table-column searchable field="rut" label="RUT">{{
                props.row.rut
              }}</b-table-column>
              <b-table-column
                searchable
                field="email"
                label="Correo Electronico"
                >{{ props.row.email }}</b-table-column
              >

              <b-table-column width="200px" label="Action">
                <b-button
                  type="is-primary is-small"
                  @click="editBasic(props.row.id)"
                  >Editar</b-button
                >
                <b-button
                style="margin-left: 10px"
                  type="is-danger is-small"
                  @click="openModalReset(props.row.id)"
                  >Resetear Clave</b-button
                >
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from "../../../../template/PlantillaContenido";
import createUser from "../../../../components/administrative/manteiners/user/create";
import ResetPassword from "../../../../components/manteiners/user/ResetPassword";

export default {
  components: {
    PlantillaContenido: PlantillaContenido,
    createUser: createUser,
  },
  data() {
    return {
      user_id: null,
      listUsers: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5,
    };
  },
  mounted: function () {
    console.log("fdgjgk");
    this.chargeListUser();
  },
  methods: {
    openBasic() {
      this.isComponentModalActive = true;
    },
    closeBasic() {
      this.user_id = null;
      this.isComponentModalActive = false;
    },
    editBasic(id) {
      this.user_id = id;
      this.isComponentModalActive = true;
    },
    chargeListUser() {
      this.loading = true;
      this.listUsers = [];
      this.$http.get(`api/${localStorage.getItem("perfil")}/user`).then(
        (response) => {
          this.listUsers = response.body.data;
          console.log(this.listUsers);
          this.loading = false;
        },
        (response) => {
          console.log("error: ", response);
        }
      );
    },
    openModalReset(id) {
      this.$buefy.modal.open({
        parent: this,
        component: ResetPassword,
        props: {
          user_id: id,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
  },
};
</script>

